import Vuex from  'vuex'
import Vue from 'vue'
Vue.use(Vuex);

import cart from "./client/cart";

export default new Vuex.Store({
    state: {
        loading: false,
        isLoggedIn: false,
        errors: {},
        response: {},
        success: false
    },
    mutations: {
        SET_LOADING(state, data) {
            state.loading = data;
        },
        SET_IS_LOGGED_IN(state, data) {
            state.isLoggedIn = data;
        },
        SET_ERRORS(state, data) {
            state.errors = data;
        },
        SET_RESPONSE(state, data) {
            state.response = data;
        },
        SET_SUCCESS(state, data) {
            state.success = data;
        }
    },
    modules: {
        cart
    }
});